import { useEffect } from "react";
import { useLocation } from "wouter";

/** Keep server-rendered URL metadata correct after client-side navigation. */
export function useSiteMetadata() {
  const [location] = useLocation();
  useEffect(() => {
    const config = document.getElementById("site-config");
    if (!config?.textContent) return;
    const { origin } = JSON.parse(config.textContent) as { origin: string };
    const url = origin + "/" + location.split(/[?#]/)[0].replace(/^\/+/, "");
    document.querySelector<HTMLLinkElement>('link[rel="canonical"]')?.setAttribute("href", url);
    document.querySelector<HTMLMetaElement>('meta[property="og:url"]')?.setAttribute("content", url);
    // Clear the previous page's schema immediately, including on private routes.
    document.getElementById("page-schema")?.remove();
    const controller = new AbortController();
    fetch(`/api/page-schema?path=${encodeURIComponent(location.split(/[?#]/)[0])}`, {
      signal: controller.signal,
    }).then(response => {
      if (!response.ok) throw new Error("Unable to load page structured data");
      return response.json();
    }).then(schema => {
      if (!schema || controller.signal.aborted) return;
      const script = document.createElement("script");
      script.id = "page-schema";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema).replace(/</g, "\\u003c");
      document.head.appendChild(script);
    }).catch(error => {
      if (error.name !== "AbortError") console.error("Page structured data unavailable");
    });
    return () => {
      controller.abort();
      document.getElementById("page-schema")?.remove();
    };
  }, [location]);
}